// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/fb-decode.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/fb-decode/fb-decode.js';
import g1 from '../lessons/meteorology/fb-decode/fb-issue-times-and-header.js';

mount([g0, g1]);
